export const categories = [
    {
      id: 1,
      name: "Test",
      color: "#FF4B5F"
    },
    {
      id: 2,
      name: "Homework",
      color: "#75D23D"
    },
    {
      id: 3,
      name: "Study Material",
      color: "#0398F7"
    },
    {
      id: 4,
      name: "Other",
      color: "#FFEB00"
    },
];